import { useContext } from "react";
import { PartnerMeContext, type PartnerMeContextValue } from "./PartnerMeContext";

/**
 * Reads the shared `GET /api/partner/me` record with its `setMe` setter and
 * `settled` and `error` flags. Throws outside a `PartnerMeProvider`, so a wiring
 * mistake fails loudly.
 */
export function usePartnerMe(): PartnerMeContextValue {
  const ctx = useContext(PartnerMeContext);
  if (ctx === null) {
    throw new Error("usePartnerMe must be used within a PartnerMeProvider");
  }
  return ctx;
}
